import React, { useEffect } from 'react';
import { Page } from '@components/page';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { Header } from './components/header';
import { Body } from './components/body';
import { CardTable } from '@components/table/styled';
import { Col } from 'antd';
import { translate } from '@components/i18n';
import { fetchItemDeadline } from '@redux/slices/item-deadline';

export const ItemDeadline: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchItemDeadline({ current: 1, pageSize: 10 }));
    }, []);

    return (
        <Page
            title={translate('pages.itemDeadline')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Col span={22} style={{ alignSelf: 'center' }}>
                <h2 style={{ marginTop: '15px' }}>
                    {translate('titlePages.itemDeadline')}
                </h2>
                <CardTable>
                    <Header />
                    <Body />
                </CardTable>
            </Col>
        </Page>
    );
};
